// extracted by mini-css-extract-plugin
module.exports = {"codeContainer":"Registrations_codeContainer__1SAG5"};